import {JOB_REQUEST_STATUS} from "../../core/constants";
import {UtilitiesService} from "../../core/_services/utilities.service";
import {Vehicle} from "./vehicle";
import {WrenchLocation} from "./location";
import {PaymentMethod} from "./paymentmethod";

export class JobRequest {
    static readonly REFERRER_TYPE_PARTNER = 1;
    static readonly REFERRER_TYPE_CUSTOMER = 2;
    static readonly REFERRER_TYPE_LANDING_PAGE_DETAIL = 3;

    id: number;
    userId: number;
    vehicle: Vehicle;
    vehicleId: number;
    contactId: number;
    flexible: boolean;
    referrerId: number;
    referrerType: number;
    status: number;
    type: number;
    leadTime: number;
    createdBy: number;
    approved: boolean;
    startDate: string;
    services: any[];
    masterUserId: number;
    fleet: boolean;
    serviceCodes?: number[];
    location?: WrenchLocation;
    paymentMethod?: PaymentMethod | unknown;
    paymentMethodId?: number;
    times: any[];
    userFirstName: string;
    userLastName: string;
    approvalName: string;
    vehicleYear: number;
    vehicleMake: string;
    vehicleModel: string;
    vehicleTrim: string;
    vehicleLicense: string;
    vehicleVin: string;
    vehicleState: string;
    vehicleLabel: string;
    notes: string;
    bookingHours: number;
    quote: any;
    state: string;
    city: string;
    price: number;
    receipt: any;
    locationId: number;

    // TODO: extend class for frontend properties
    // front end
    vehicleDisplayName?: string;
    userDisplayName?: string;
    checked: boolean;

    constructor(data: any) {
        Object.assign(this, data);
    }

    // this status is only set on JRs that are created or assigned to employees, then manager has to approve
    isPendingApproval() {
        return this.status === JOB_REQUEST_STATUS.PENDING_APPROVAL;
    } // isPendingApproval()

    isPricing() {
        return this.status === JOB_REQUEST_STATUS.PRICING;
    } // isPricing()

    isReadyToSchedule() {
        // Don't include pending JR that already has been scheduled...as might be the case if a JR is scheduled by the
        // user and then the price is increased on the quote.
        return (this.status === JOB_REQUEST_STATUS.PENDING && UtilitiesService.isEmpty(this.times)) || (UtilitiesService.isEmpty(this.times) && this.status === JOB_REQUEST_STATUS.READY);
    } // isReadyToSchedule(

    isSaved() {
        return this.status === JOB_REQUEST_STATUS.SAVED;
    } // isSaved(

    isDenied() {
        return this.status === JOB_REQUEST_STATUS.CANCELLED;
    }  // isDenied()

    validateStartDate() {
        let minDateTime = new Date();
        // add 45 mins of lead time to now for minimum start date time
        minDateTime.setMinutes(minDateTime.getMinutes() + 45);
        let startDate = UtilitiesService.dateFromString(this.startDate);
        if (startDate < minDateTime) {
            return false;
        } else {
            return true;
        }
    } // validateStartDate()
}
